<!-- 广告位 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap" >
        <el-tabs  v-model="activeName" @tab-click="changeTabs"  type="card">
            <el-tab-pane label="网页广告" name="a" >  
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" :inline="true">
                <el-row :gutter="24">
                    <el-col :span="8">
                    <el-form-item label="网页广告" prop="imageUrl" class="form" >
                    <el-upload class="avatar-uploader" ref="coverPicUpload1" action="" 
                        list-type="picture" accept="image/*"
                        multiple 
                        :limit="1" 
                        name="file" 
                        :file-list="fileList1"
                        :on-remove="handleRemove"
                        :http-request="handleRequest"
                        :before-upload="handleBeforeUpload" 
                        >
                        <el-button size="small" type="primary">上传图片</el-button>
                    </el-upload>
                    <span class="red">图片尺寸为：1920*250</span>
                </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="广告链接" prop="adv-link">
                        <el-input v-model="ruleForm.imageLink" placeholder="请输入广告链接" style="width:400px" />
                    </el-form-item>
                </el-col>
                </el-row>
                <el-form-item>
                    <el-button round block type="primary" @click="submitForm('ruleForm')" 
                    class="pub-submit" :disabled="disabled">
                        发布
                    </el-button>                            
                </el-form-item>
            </el-form>
            <el-table border :data="tableDataPC" style="width: 100%;" >
                <el-table-column  type="index" width="100" align="center"/>
                <el-table-column   label="广告图片" >
                    <template slot-scope="scope">
                        <el-image :src="scope.row.imageUrl" :preview-src-list="scope.row.srcList" />
                    </template>
                </el-table-column>
                <el-table-column   label="广告链接" >
                    <template slot-scope="scope">
                        <el-link :href="scope.row.imageLink" target="_blank">{{ scope.row.imageLink }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column  fixed="right" label="操作"  width="180">
                    <template slot-scope="scope">                       
                        <el-button @click="handleUpdate(scope.row,'a')" type="text" 
                        icon="el-icon-edit" size="small">编辑</el-button>
                        <el-button @click="handleDelete(scope.row,50)" type="text" 
                        icon="el-icon-delete" size="small">删除</el-button>
                    </template>                   
                </el-table-column>
            </el-table>
            </el-tab-pane>
            <el-tab-pane label="小程序广告" name="b">
                <el-form :model="ruleFormWX" :rules="rules2" ref="ruleFormWX" 
                    class="demo-ruleForm" :inline="true">                   
                    <el-row :gutter="24">
                    <el-col :span="10">
                        <el-form-item label="小程序广告" prop="imageUrl" class="form" >                        
                            <el-upload class="avatar-uploader" ref="coverPicUpload2" action="" 
                                list-type="picture" accept="image/*"
                                multiple 
                                :limit="1" 
                                name="file" 
                                :file-list="fileList2"
                                :on-remove="handleRemove2"
                                :http-request="handleRequest2"
                                :before-upload="handleBeforeUpload" 
                                >
                                <el-button size="small" type="primary">上传图片</el-button>
                            </el-upload>
                            <span class="red">图片尺寸为：375*150</span>                       
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="链接类型" prop="adv-link">
                            <el-radio-group v-model="ruleFormWX.linkType">
                                <el-radio  label="1">公众号链接</el-radio>
                                <el-radio  label="2">新闻链接</el-radio>
                                <el-radio  label="3">商品链接</el-radio>
                            </el-radio-group>                            
                        </el-form-item>
                        <el-form-item label="广告链接" prop="adv-link" v-if="ruleFormWX.linkType === '1'">
                            <el-input v-model="ruleFormWX.imageLink"  :clearable="true"
                            placeholder="请输入广告链接" style="width:400px" />
                            <el-row class="red">公众号链接请直接输入链接</el-row>
                        </el-form-item>
                        <el-form-item label="新闻链接" prop="adv-link" v-if="ruleFormWX.linkType === '2'">
                            <el-autocomplete style="width: 400px;" :clearable="true" 
                                v-model="ruleFormWX.imageLink"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入新闻标题"
                                :trigger-on-focus="false"
                                @select="handleSelect"
                            ></el-autocomplete>
                            <el-row class="red">新闻链接，请输入新闻标题选择对应新闻</el-row>
                        </el-form-item>                        
                        <el-form-item label="商品链接" prop="adv-link" v-if="ruleFormWX.linkType === '3'">
                            <el-autocomplete style="width: 400px;" :clearable="true" 
                                v-model="ruleForm.imageLink"
                                :fetch-suggestions="queryProductSearch"
                                placeholder="请输入商品名称"
                                :trigger-on-focus="false"
                                @select="handleSelect"
                            ></el-autocomplete>
                            <el-row class="red">商品链接，请输入商品名称选择对应商品</el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button round block type="primary" @click="submitFormWX('ruleFormWX')" 
                    class="pub-submit" :disabled="disabled">
                        发布
                    </el-button>                            
                </el-form-item>             
            </el-form>
            <el-table border :data="tableDataWX" style="width: 100%;" >
                <el-table-column  type="index" width="100" align="center"/>
                <el-table-column   label="广告图片" >
                    <template slot-scope="scope">
                        <el-image :src="scope.row.imageUrl" :preview-src-list="scope.row.srcList" />
                    </template>
                </el-table-column>
                <el-table-column   label="广告链接" >
                    <template slot-scope="scope">
                        <el-link :href="scope.row.imageLink" target="_blank">{{ scope.row.imageLink }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column  fixed="right" label="操作"  width="180">
                    <template slot-scope="scope">                       
                        <el-button @click="handleUpdate(scope.row,'b')" type="text" 
                        icon="el-icon-edit" size="small">编辑</el-button>
                        <el-button @click="handleDelete(scope.row,51)" type="text" 
                        icon="el-icon-delete" size="small">删除</el-button>
                    </template>                   
                </el-table-column>
            </el-table>
            </el-tab-pane>
        </el-tabs>        
    </div>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
export default {
    components:{
        PageBack,
    },
    data() {
        return {
            loading: false,
            ruleForm: {
                title: '',
                imageUrl: '', 
                imageLink: ''                    
            },
            ruleFormWX: {
                title: '',
                imageUrl: '',  
                imageLink: '',
                id: '',
                linkType: '',              
            },
            rules:{
                imageUrl: [
                    { required: true, message: '请上传广告位图片', trigger: 'change' },
                ],
            },
            rules2:{
                imageUrl: [
                    { required: true, message: '请上传广告位图片', trigger: 'change' },
                ],
            },
            disabled: false,
            imageUrl: '',
            flag: 1,
            originalId: 1,
            originalWxId:1,
            activeName: 'a',
            fileList1: [], //网页广告
            fileList2: [], //小程序广告,
            tableDataPC: [],
            tableDataWX: []
        }
    },
    created() {
        // this.serialId = this.$route.query.id
        this.activeName = this.$route.query.type || 'a'
    },
    mounted() {
        this.getAdvertPC()
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
    },
    methods: {
        getAdvertPC(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 50  
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){                        
                        let list = result.map(item=>{
                            return{
                                imageUrl: item['中文描述'],
                                value: item['中文描述'],
                                id: item['词条索引'],
                                srcList: [item['中文描述']],
                                imageLink: item['备注'] ? item['备注'] : '',
                                linkType: item.v_type
                            }
                        })   
                        this.tableDataPC = list
                        if(this.serialId){
                            let arr = list.filter(i=> i.id === this.serialId)
                            console.log(arr)
                            this.ruleForm = {...arr[0]}  
                            this.originalId = this.serialId
                        }else{
                            let idArr = list.map(i=>Number(i.id))
                            let maxId = Math.max(...idArr)
                            this.originalId = maxId + 1
                        }
                    }     
                }
            })
        },
        getAdvertWX(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 51  
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){                        
                        let list = result.map(item=>{
                            return{
                                imageUrl: item['中文描述'],
                                value: item['中文描述'],
                                id: item['词条索引'],
                                srcList: [item['中文描述']],
                                imageLink: item['备注'] ? item['备注'] : '',
                                linkType: item.v_type
                            }
                        })   
                        this.tableDataWX = list
                        if(this.serialId){
                            let arr = list.filter(i=> i.id === this.serialId)
                            this.ruleFormWX = {...arr[0]}  
                            this.originalWxId = this.serialId
                        }else{
                            let idArr = list.map(i=>Number(i.id))
                            let maxId = Math.max(...idArr)
                            this.originalWxId = maxId + 1
                        }
                    }     
                }
            })
        },
        submitForm(formName){             
            this.$refs[formName].validate((valid) => {    
                if(valid){  
                    this.loading = true   
                    this.disabled = true                
                    this.handleSubmit()
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        handleSubmit(){          
            let params = {
                opcode: this.$code.PubAdvert,
                i_no: 50,
                v_name: this.originalId,
                v_caption: this.ruleForm.imageUrl,
                flag: this.flag,
                v_summary :   this.ruleForm.imageLink              
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.loading = false                    
                    this.$message.success('广告发布成功！')
                    this.flag = 1
                    this.fileList1 = []
                    this.getAdvertPC()
                    // this.$router.go(-1)
                    setTimeout(()=>{
                        this.disabled = false 
                    },1000)
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        submitFormWX(formName){             
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.loading = true
                    this.disabled = true 
                    this.handleSubmitWx()
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        handleSubmitWx(){
            let imageLink = ''
            if(this.ruleFormWX.linkType === '2'){   
                if(this.ruleFormWX.imageUrl === ''){
                    this.$message.success('请上传图片')
                    return false
                }            
                if(this.ruleFormWX.id === ''){
                    this.$message.success('请选择对应新闻标题')
                    return false
                }else{
                    imageLink = this.ruleFormWX.id
                }
            }else if(this.ruleFormWX.linkType === '1'){
                if(this.ruleFormWX.imageLink === ''){
                    this.$message.success('请输入广告链接')
                    return false
                }else{
                    imageLink = this.ruleFormWX.imageLink   
                }                          
            }else if(this.ruleFormWX.linkType === '3'){   
                if(this.ruleFormWX.imageUrl === ''){
                    this.$message.success('请上传图片')
                    return false
                }            
                if(this.ruleFormWX.id === ''){
                    this.$message.success('请选择对应商品名称')
                    return false
                }else{
                    imageLink = this.ruleFormWX.id
                }
            }    
            let params = {
                opcode: this.$code.PubAdvert,
                i_no: 51,
                v_name: this.originalWxId,
                v_caption: this.ruleFormWX.imageUrl,
                flag: this.flag,
                v_summary : imageLink,
                v_type: this.ruleFormWX.linkType             
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.loading = false                    
                    this.$message.success('广告发布成功！')
                    this.flag = 1
                    this.fileList2 = []                    
                    this.getAdvertWX()
                    setTimeout(()=>{
                        this.disabled = false 
                        this.ruleFormWX.imageUrl = ''
                        this.ruleFormWX.imageLink = ''
                        this.ruleFormWX.id = ''
                    },1000)
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        async handleRequest(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.imageUrl= url
            this.ruleForm.imageUrl = this.$global.uploadUrl + url
            this.fileList1 = [
                {name:file.file.name,url: this.ruleForm.imageUrl }
            ]
            this.loading.close();
            this.$refs.coverPicUpload1.clearFiles()
        },  
        handleRemove(file, fileList) {
            this.imageUrl = ''
            this.ruleForm.imageUrl = ''
            this.fileList1 = []
        },   
        handleBeforeUpload() {
            this.loading = true
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        changeTabs(){
            if(this.activeName === 'b'){
                this.fileList1= []
                this.ruleForm.imageLink = ''
                
                this.getAdvertWX()
            }else{
                this.fileList2= []
                this.getAdvertPC()
                this.ruleFormWX.imageLink = ''
                this.ruleFormWX.id = ''
                this.ruleFormWX.linkType = ''
            }
        },
        async handleRequest2(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleFormWX.imageUrl = this.$global.uploadUrl + url
            this.fileList2 = [
                {name:file.file.name,url: this.ruleFormWX.imageUrl }
            ]
            this.loading.close();
            this.$refs.coverPicUpload2.clearFiles()
        }, 
        handleRemove2(file, fileList) {
            this.ruleFormWX.imageUrl = ''
            this.fileList2 = []
        },  
        handleDelete(row,no){
            this.$confirm('确定删除这条广告吗?','提示').then(()=>{
            this.deleteConfirm(row,no)
            }).catch(err=>{
                console.log(err)
            })
        },
        deleteConfirm(row,no){
            let params = {
                opcode: this.$code.PubAdvert,
                i_no: no,
                v_name: row.id,
                v_caption: row.value,
                flag: 3            
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success(res.Message)
                    if(no === 50){
                        this.getAdvertPC()
                    }else{
                        this.getAdvertWX()
                    }
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        handleUpdate(row,type){  
            console.log(row)        
            this.flag = 2    
            this.disabled = false          
            if(type === 'a'){
                 //网页广告 
                this.originalId = row.id
                this.fileList1 = [{name:'',url: row.imageUrl }]
                this.ruleForm.imageUrl = row.imageUrl
                this.ruleForm.imageLink = row.imageLink
            }else{
                 //小程序广告 
                this.originalWxId = row.id
                this.fileList2 = [{name:'',url: row.imageUrl }]
                this.ruleFormWX.imageUrl = row.imageUrl
                this.ruleFormWX.imageLink = row.imageLink
                this.ruleFormWX.linkType = row.linkType
            }
        }, 
        async querySearch(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },
        // 模糊搜索查询
        getUserInfoSearch(val){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.NewsQuery,
                        i_serial: 0,
                        v_title: val,
                        v_flag: '',
                        c_status:'',
                    }
                    // 查询信息
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){
                                this.ruleFormWX.id = ''

                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value:item['标题'],
                                        id: item['序号'],                                       
                                    }
                                })                            
                                resolve(arr)                         
                            }
                    }
                    }).catch(err => { reject(err)})
                }else{
                    this.ruleFormWX.id = ''
                }
            })         
        },         
        handleSelect(row){
            console.log('select',row)
            this.ruleFormWX.imageLink = row.value
            this.ruleFormWX.id = row.id
        },  
        async queryProductSearch(queryString, cb){
            let result = queryString ? await this.getProductSearch(queryString) : []  
            cb(result)
        },
        // 模糊搜索查询
        getProductSearch(val){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.ProductSearch,
                        page: 1,
                        pagesize: 10,
                        v_evaluate: "",
                        v_goods_title: val,
                        v_prices: "",
                    }
                    // 查询信息
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){
                                this.ruleForm.id = ''    
                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value:item['商品标题'],
                                        id: item['商品标识'],                                       
                                    }
                                })                            
                                resolve(arr)                         
                            }
                    }
                    }).catch(err => { reject(err)})
                }else{
                    this.ruleForm.id = ''
                }
            })         
        },     
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.image {
  position: relative;

  .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }

  &:hover .mask {
    opacity: 1;
  }
}
.container {
    background-color: #fff;
}

.detail-wrap {
    width: 1000px;
    padding-bottom: 40px;
    font-size: 16px;
    line-height: 28px;
}
.pub-submit{
    margin-top: 16px;
    width: 200px;
    font-size: 16px;
}
.el-image{
    height: 100px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/news/advert.vue